import type { APIs } from './index';
import type { OurContext } from '../context';
import { testClaims } from '../context/claims';
import type { SubmitResponse } from './submit';
import qrSvg from './test_assets/qr.svg';

export const testAPIs: APIs = {
  validateClaims: async () => testClaims,
  pollStatus: async (context: OurContext) => {
    switch (context.apiAuth) {
      case 'pending':
        return 'PENDING';
      case 'accepted':
        return 'ACCEPTED';
      case 'rejected':
        return 'REJECTED';
      case 'failed':
        return 'FAILED';
      case 'timeout':
        return 'TIMEOUT';
      case 'error':
        return 'ERROR';
    }
    return 'PENDING';
  },
  submitNumber: async (_, number): Promise<SubmitResponse> => ({
    phoneNumber: number,
  }),
  cancel: async () => void 0,
  getQr: async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return { url: qrSvg };
  },
  getMerchantDetails: async () => ({
    companyName: 'Test Company',
    displayName: 'The Company',
    msn: '58859',
    logoUrl: 'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png',
  }),
};
